module.exports = __webpack_public_path__ + "static/media/full_5.616210df.jpg";